module.exports = __webpack_public_path__ + "static/media/MarkerApiKuning.71736515.svg";